// /src/components/layout/MobileMenu.js

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaTimes, FaSignInAlt, FaUserPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const MobileMenu = ({ isOpen, setIsOpen, userRole }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/90 z-50 md:hidden">
      <div className="fixed inset-y-0 left-0 w-64 bg-gray-800 shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h2 className="text-xl font-bold text-white">
            {t('auth.common.brandName')}
          </h2>
          <button
            onClick={() => setIsOpen(false)}
            className="p-2 text-gray-400 hover:text-white rounded-lg"
          >
            <FaTimes className="h-6 w-6" />
          </button>
        </div>

        {/* Menu Content */}
        <div className="p-4">
          {userRole === 'guest' ? (
            <div className="space-y-4">
              <p className="text-sm text-gray-400 mb-4">
                {t('sidebar.navigation.guestActions.description')}
              </p>
              <button
                onClick={() => handleNavigation('/login')}
                className="w-full px-4 py-2 bg-indigo-600 text-white rounded-lg 
                         hover:bg-indigo-700 transition-colors duration-200 flex 
                         items-center justify-center"
              >
                <FaSignInAlt className="mr-2" />
                {t('sidebar.navigation.guestActions.login')}
              </button>
              <button
                onClick={() => handleNavigation('/signup')}
                className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg 
                         hover:bg-gray-600 transition-colors duration-200 flex 
                         items-center justify-center"
              >
                <FaUserPlus className="mr-2" />
                {t('sidebar.navigation.guestActions.signup')}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;